import { render, staticRenderFns } from "./AddUnavailability.vue?vue&type=template&id=add15954&scoped=true&"
import script from "./AddUnavailability.vue?vue&type=script&lang=js&"
export * from "./AddUnavailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add15954",
  null
  
)

export default component.exports